export default "__VITE_ASSET__DytDGZXn__"